var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/**
 * A reusable error component
 */
import styled from 'styled-components';
import React from 'react';
import { Text, Container, TextBox } from '../Loading/Loading.styled';
import { ErrorGraphic } from '../assets/icons/Error';
import { colors } from '../styleConstants';
import { Title } from '../Loading/Loading.styled';
var ErrorTitle = styled(Title)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), colors.accentRed);
var Error = function () {
    return (React.createElement(Container, null,
        React.createElement(ErrorGraphic, null),
        React.createElement(TextBox, null,
            React.createElement(ErrorTitle, null, "There was an error."),
            React.createElement(Text, null, "The server encountered an internal error and was not able to complete your request."))));
};
export default Error;
var templateObject_1;
